<template>
<div>

    <div class="itemList">
        <div class="itemDiv" v-for="item in paUserList" :key="item.id">

            <div class="companyInfoBox">
                <div>申请人姓名: {{item.nickname}}</div>
                <div>申请人电话号码: {{item.phone}}</div>
            </div>
                <div class="actionBox">
                    <el-tooltip class="item" effect="dark" content="审核通过" placement="top-start">
                        <el-button  type="success" icon="el-icon-check" @click="setCompanyStatus(item)" circle></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="审核失败" placement="top-start">
                        <el-button  type="danger" icon="el-icon-close" @click="setCompanyStatus(item)" circle></el-button>
                    </el-tooltip>
                </div>
            </div>
        </div>
        <div class="imgShadow" v-if="ckMode">
            <div class="close" @click="hideCompanyAudit" style="background: transparent">
                <el-button icon="el-icon-close" circle></el-button>
            </div>
            <div>
                <div class="formtitle">分配主体企业</div>
                <el-select style="width: 400px" v-model="companyName" clearable filterable remote reserve-keyword
                placeholder="请输入公司名称进行搜索" :remote-method="getSearchSuggestion" :loading="searchloading"
                @clear="searchClear" @change="searchChange">
                <el-option v-for="item in dataList" :key="item.id"
                  :label="item.company" :value="item">
                </el-option>
              </el-select>
              <div class="formtitle">级别选择</div>
              <div>
                <el-radio v-model="radio" label="1">初级顾问</el-radio>
                <el-radio v-model="radio" label="2">高级顾问</el-radio>
                <el-radio v-model="radio" label="3">合伙人</el-radio>

              </div>
                <div class="actionBox">
                    <el-tooltip class="item" effect="dark" content="审核通过" placement="top-start">
                        <el-button  type="success" icon="el-icon-check" @click="setCompanyStatus1(1)" circle></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="审核失败" placement="top-start">
                        <el-button  type="danger" icon="el-icon-close" @click="setCompanyStatus1(2)" circle></el-button>
                    </el-tooltip>
                </div>
            </div>

        </div>
        <div class="block">
            <el-pagination @current-change="handleCurrentChange" :current-page="pageNumber" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="pageTotal">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
// var qs = require('qs');
export default {
    name: 'paUser',
    props: {},
    data() {
        return {
            companyName: '',
            pageSize: 20,
            pageNumber: 1,
            searchloading: false,
            pageTotal: 0,
            radio: "1",
            paUserList: [],
            pageSize1: 20,
            pageNumber1: 1,
            pageTotal1: 0,
            dataList: [],
            setCom: false,
            setid: '',
            setItem: false,
            selectType: '待审核',
            ckMode: false,
            activeItem: false,
            selectTypeArray: {
                "待审核": 1,
                "审核成功": 2,
                "审核失败": 3,
                "终止合作": 4,
                "未认证": 0
            }

        }
    },
    methods: {
        searchClear: function (e) {
            this.setCom = e === '' ? false : e
            this.searchloading = false
        },
        searchChange: function (e) {
            this.setCom = e === '' ? false : e
            this.companyName = e.company
        },
        getSearchSuggestion: function (e) {
            let that = this
            that.searchloading = true
            let url = ''
            url = Config.path + '/api/platform/company/getCompanyList';
            let data = {
                status: 2,
                pageSize1: this.pageSize,
                pageNum1: this.pageNumber,
                searchKey: e
            }
            axios({
                method: 'POST',
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: data,
            }).then(function (response) {
                that.searchloading = false
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    let demo = response.data.content.list
                    that.dataList = demo
                    that.pageTotal1 = response.data.content.total
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                that.searchloading = false
                console.log(error)
            })


        },
        showCompanyAudit: function (e) {
            this.activeItem = e
            this.ckMode = true
        },
        hideCompanyAudit: function () {
            this.ckMode = false
        },
        getPaUserList: function () {
            let that = this
            let url = ''
            url = Config.path + '/api/platform/apply/getAuthPAList';
            let data = {
                pageSize: this.pageSize,
                pageNum: this.pageNumber
            }
            axios({
                method: 'POST',
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: data,
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    let demo = response.data.content.list
                    that.paUserList = demo
                    that.pageTotal = response.data.content.total
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        getCompanyList: function () {
            let that = this
            let url = ''
            url = Config.path + '/api/platform/company/getCompanyList';
            let data = {
                status: 2,
                pageSize1: this.pageSize,
                pageNum1: this.pageNumber
            }
            if (this.companyName !== '' && this.companyName !== undefined) {
                data.searchKey = this.companyName
            }
            axios({
                method: 'POST',
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: data,
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    let demo = response.data.content.list
                    that.dataList = demo
                    that.pageTotal1 = response.data.content.total
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        handleCurrentChange: function (val) {
            this.pageNumber = val
            this.getPaUserList()
        },
        setCompanyStatus: function (item) {
            this.setItem = item
            this.ckMode = true
        },
        setCompanyStatus1: function (index) {
            let that = this
            let url = ''
            url = Config.path + '/api/platform/apply/authApplyPA';
            let data = {
                "id": this.setItem.id,
                "verifyStatus":index.toString(),
                "companyID": this.setCom.id,
                "roleLevle": Number(this.radio)
            }
            axios({
                method: 'POST',
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: data,
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {

                    debugger
                    that.ckMode = false
                    that.getPaUserList()
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        czPassword: function (item) {
            let that = this
            let url = ''
            url = Config.path + '/api/platform/company/resetPassword';
            let data = {
                id: item.id
            }
            axios({
                method: 'POST',
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: data,
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.$message({
                        message: '重置密码成功',
                        type: 'success'
                    });
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        }
    },
    created: function () {
        this.getPaUserList();
        this.getCompanyList();
    },
    mounted: function () {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.itemList {
    margin-top: 20px;
}

.formtitle{
    color: #464646;
    padding: 10px 0;
}

.itemList .itemDiv {
    background-color: #ffffff;
    width: 80%;
    margin: 0 auto 15px auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    box-sizing: border-box;
    padding: 25px;
    border-radius: 8px;
    min-height: 100px;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
    position: relative;
}

.itemList .itemDiv .logoBox {}

.itemList .itemDiv .logoBox img {
    width: 80px;
    height: 80px;
    border-radius: 8px;
}

.itemList .itemDiv .companyInfoBox {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    min-height: 100px;
    margin-left: 30px;
    color: #909399;
}

.itemList .itemDiv .companyAudit {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    min-height: 100px;
    position: absolute;
    right: 130px;
}

.itemList .itemDiv .companyAudit .imageAction {}

.itemList .itemDiv .companyAudit .imageAction img {
    height: 160px;
}

.itemList .itemDiv .companyAudit .textAction {
    font-size: 12px;
    color: rgb(123, 123, 123);
    text-align: center;
}

.itemList .itemDiv .actionBox {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    min-height: 100px;
    position: absolute;
    right: 40px;
}

.itemList .itemDiv .actionBox button {
    margin: 0;
}

.imgShadow {
    width: 100vw;
    height: 100vh;
    position: fixed;
    background-color: rgba(0, 0, 0, 0.7);
    top: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.imgShadow img {
    width: 500px;
}

.imgShadow>div {
    margin-left: 50px;
    background: #ffffff;
    padding: 30px;
    border-radius: 10px;
}

.imgShadow .textAction {
    color: #ffffff;
    padding: 20px 0;
    text-align: center;
}

.imgShadow .actionBox {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
}

.imgShadow .close {
    position: absolute;
    top: 30px;
    right: 30px;
}

.block {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
}
</style>
